import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./en.json";
import ru from "./ru.json";
import eventTranslations from "../data/events.json";

const resources = {
  en: {
    translation: en,
    events: eventTranslations.en,
    b2b: en.b2b,
  },
  "en-GB": {
    translation: en,
    events: eventTranslations.en,
    b2b: en.b2b,
  },
  "en-US": {
    translation: en,
    events: eventTranslations.en,
    b2b: en.b2b,
  },
  "en-AU": {
    translation: en,
    events: eventTranslations.en,
    b2b: en.b2b,
  },
  "en-CA": {
    translation: en,
    events: eventTranslations.en,
    b2b: en.b2b,
  },
  ru: {
    translation: ru,
    events: eventTranslations.ru,
    b2b: ru.b2b,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: {
      "en-GB": ["en"],
      "en-US": ["en"],
      "en-AU": ["en"],
      "en-CA": ["en"],
      default: ["en"],
    },
    defaultNS: "translation",
    // If a key is missing in a specific namespace (e.g. `b2b`),
    // fall back to the root `translation` namespace instead of showing raw keys.
    // This helps avoid UI showing `auth.someKey` when the key exists in `translation`.
    fallbackNS: ["translation"],
    ns: ["translation", "events", "b2b"],
    debug: true, // Enable debug mode to investigate translation issues
    supportedLngs: ["en", "en-GB", "en-US", "en-AU", "en-CA", "ru"],
    nonExplicitSupportedLngs: true, // Allow fallback to base language
    detection: {
      order: [
        "querystring",
        "cookie",
        "localStorage",
        "htmlTag",
        "path",
        "subdomain",
      ],
      caches: ["localStorage", "cookie"],
      convertDetectedLanguage: (lng) => {
        // Convert en-GB, en-US, etc. to just "en"
        if (lng && lng.startsWith("en-")) {
          return "en";
        }
        return lng;
      },
    },
    interpolation: {
      escapeValue: false,
      formatSeparator: ",",
      format: function (value, format, lng) {
        if (format === "uppercase") return value.toUpperCase();
        return value;
      },
    },
  });

export default i18n;
